/**
 * This mixin is used to display the total number of a resource
 * that is being displayed or selected, and is used by any component
 * that uses data tables
 */

export default {
  methods: {
    showItemTotals_pluralize(number, singularName, pluralName) {
      return number !== 1 ? pluralName : singularName;
    },
    showItemTotals_show(numSelectedItems, totalItems, singularName, pluralName) {
      const total = numSelectedItems > 0 ? numSelectedItems : (totalItems || 0);
      const resourceName = this.showItemTotals_pluralize(total, singularName, pluralName);

      return numSelectedItems > 0 ? `${total} ${resourceName} Selected` : `${total} Total ${resourceName}`;
    },
  },
};
